import React from 'react';

import { ResumeContentContext } from './types';
import { renderBrokerFirstContent, renderBrokerLastContent } from './renderers/broker';
import { renderLoggedInContent } from './renderers/loggedIn';
import { renderNotLoggedInContent } from './renderers/notLoggedIn';

/**
 * Renderiza el contenido del footer del resumen del préstamo
 */
export const renderFooterContent = (context: ResumeContentContext) => {
  if (context.flags.isBrokerFirst) {
    return renderBrokerFirstContent(context);
  }

  if (context.flags.isBrokerLast) {
    return renderBrokerLastContent(context);
  }

  const body = context.flags.isLoggedIn
    ? renderLoggedInContent(context)
    : renderNotLoggedInContent(context);

  const shouldHideTextInfoBorrower = context.isSomeoneElse && !context.flags.isProcessingTeamMode;
  const resumeContentClassName = shouldHideTextInfoBorrower
    ? 'resume-content hide-text-info-borrower'
    : 'resume-content';

  return (
    <React.Fragment>
      <style>
        {`.resume-content .text-info-borrower span { font-size: 20px !important; }`}
      </style>
      <div className={resumeContentClassName}>
        {body}
      </div>
    </React.Fragment>
  );
};
